export default __webpack_public_path__ + "static/media/isChat.1ec26b61.png";